<template>
  <LottieAnimation
    class="loader-w-logo"
    :animationData="animationData"
    :loop="true"
    :autoPlay="true"
    :speed="1"
  />
</template>

<script>
import { LottieAnimation } from 'lottie-web-vue'
import animationData from '@/assets/lottieJSONs/wizard-logo.json'

export default {
  name: 'LoaderWLogo',
  components: {
    LottieAnimation,
  },
  data() {
    return {
      animationData,
    }
  },
}
</script>
<style scoped>
.loader-w-logo {
  width: 180px;
  height: 138px;
}
</style>
